export const container = "fixed top-0 left-0 right-0 h-[3rem] bg-white w-full px-6 py-3 flex justify-between"
export const img = 'h-auto w-auto'
